import React from "react"
import * as styles from "./content.module.scss"
import * as quoteStyle from "./quotes.module.scss"
import Slider from "react-slick";

const Quote = (content) => {

    // If no quote is found, return false
    if (!content.content) {
        return false;
    }

    const sliderSettings = {
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 225,
        autoplaySpeed: 15000,
        slidesToShow: 1,
        arrows: false,
        slidesToScroll: 1
    };

    const quotes = content.content;
    const quotesCount = quotes.length;

    return (
        <section>
            <div className="grid-container-wrap">
                <div className="grid-container">
                    <div
                        className="grid-colstart-4-xl-min grid-colend-10-xl-min grid-colstart-3-xl-lg grid-colend-11-xl-lg grid-colstart-2-lg-sm grid-colend-12-lg-sm">
                        <blockquote className={styles.contentQuote}>

                            <Slider {...sliderSettings}
                                    className={quotesCount > 1 ? `${quoteStyle.quoteSlider}` : `${quoteStyle.quoteWrap}`}>
                                {
                                    quotes.map((quote, index) => {
                                        let quoteItem = quote.quotes;
                                        return <div key={index}>
                                            <p>{quoteItem.quote ? quoteItem.quote : ''}</p>
                                            {quoteItem.quoter &&
                                            <footer>{quoteItem.quoter}</footer>
                                            }
                                        </div>
                                    })
                                }
                            </Slider>

                        </blockquote>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Quote